import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/machine/reports/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/machine/reports/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/machine/reports/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/machine/reports/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Configuration for the right panel
            type: 'wide',
            minWidth: 200,
            rows: [RecordWithdrawalRequest, DetailsWithdrawalRequest], // Rows in the right panel
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Columns in the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager configuration
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    animate: {
                        subtype: 'out',
                    },
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index
                            if (value == 1) {
                                // If exporting to Excel
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Retiros',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If exporting to PDF
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Retiros',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown
                        },
                    },
                },
            ],
        };
        const left = {
            // Configuration for the left panel
            rows: [
                FilterWithdrawalRequests, // Filter component
                TableWithdrawalRequest, // Table component
                toolbar, // Toolbar
            ],
        };
        const avanc = {
            // Advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Header and body for advanced details
        };
        const avancResp = {
            // Responsive advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            id: 'carousel1',
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'), // Header for advanced details
                    body: right, // Body for advanced details
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        return {
            // Main configuration return
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: screen.width < 820 ? false : true, // Conditional scroll based on screen width
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        document.body.offsetWidth < 600 ? avancResp : avanc, // Responsive advanced details
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Webix ready function
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
